export function getDefaultBranchSpecification(defaultBranch: string | null) {
  return defaultBranch?.startsWith('refs/') ? defaultBranch : `refs/heads/(${defaultBranch})`
}
